import ModernSpinner, {LoadingSpinner, PulseSpinner, GradientSpinner, DotsSpinner} from './ModernSpinner';

export default ModernSpinner;
export {LoadingSpinner, PulseSpinner, GradientSpinner, DotsSpinner};
